enum Routes {
  // admin routes
  GET_LOCATION_SUGGESTION = 'GET_LOCATION_SUGGESTION',
  GET_GOOGLE_PLACE_COORDINATES = 'GET_GOOGLE_PLACE_COORDINATES',
  GET_FILE_UPLOAD_PRESIGNED_URL = 'GET_FILE_UPLOAD_PRESIGNED_URL',
  REBUILD_SURVEY_ANALYSIS = 'REBUILD_SURVEY_ANALYSIS',
  REMOVE_MEMBER = 'REMOVE_MEMBER',
  COPY_SURVEY = 'COPY_SURVEY',

  // admin naw routes
  UPLOAD_NAW_CONTACT_LIST = 'UPLOAD_NAW_CONTACT_LIST',

  // admin controlling routes
  CONTROLLING_LOAD_YEAR_REPORT = 'CONTROLLING_LOAD_YEAR_REPORT',
  CONTROLLING_OFFER_CREATE = 'CONTROLLING_OFFER_CREATE',

  // public routes
  LOAD_PUBLIC_SURVEY = 'LOAD_PUBLIC_SURVEY',
  SAVE_ANSWER_SET = 'SAVE_ANSWER_SET',

  // public NAW routes
  LOAD_PUBLIC_NAW_SURVEY = 'LOAD_PUBLIC_NAW_SURVEY',
  SAVE_NAW_ANSWER = 'SAVE_NAW_ANSWER',
  DOWNLOAD_NAW_RESULT = 'DOWNLOAD_NAW_RESULT',
}

export default Routes
